// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"643":"5b41cb2b","752":"297881d6","817":"ed0b8ac7","907":"d9d3b4ac","916":"68df7801"}[chunkId] + ".chunk.css";
};